import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { CategoriesService, CategoryDetailsResponse } from '@src/app/shared/backend/clients';
import { ConfirmationService } from 'primeng/api';
import { firstValueFrom, Subject, takeUntil } from 'rxjs';
import { PermissionService } from '@src/app/shared/services/permission.service';
import { Actions } from '@src/app/shared/backend/auth/Action';
import { DialogReasonComponent } from '@src/app/shared/components/dialog-reason/dialog-reason.component';
import { BaseViewComponent } from '@src/app/shared/components/base-list/base-view.component';

@Component({
    selector: 'app-view-category',
    templateUrl: './view-category.component.html',
    styleUrl: './view-category.component.scss',
    host: {
        class: 'app-view-category'
    },
    providers: [ConfirmationService],
    standalone: false
})
export class ViewCategoryComponent extends BaseViewComponent implements OnInit, OnDestroy {

  private readonly destroyedComponent$ = new Subject<void>();

  @ViewChild('dialog') dialog: DialogReasonComponent | undefined;

  delete: boolean = false;
  allowModifyCategory: boolean = false;
  categoryId: number = 0;
  category: CategoryDetailsResponse = {
    id: 0,
    name: '',
    code: ''
  };

  constructor(
    private permissionService: PermissionService,
    private router: Router,
    private route: ActivatedRoute,
    private categoriesService: CategoriesService) {
    super();
  }

  ngOnInit() {
    this.init();
  }

  private async init(): Promise<void> {
    this.route.params
      .pipe(takeUntil(this.destroyedComponent$))
      .subscribe(async (params) => {
        this.categoryId = Number(params['categoryId']);
        if (this.categoryId > 0) {
          await this.get();
        }
      });

    this.delete = await this.permissionService.hasActionPermissions(Actions.delete);
    this.allowModifyCategory = await this.permissionService.hasActionPermissions(Actions.modify_categories);
  }

  override async get() {
    this.getChild(this.categoryId);
  }

  override async getChild(id: any) {
    try {
      this.categoryId = id;
      this.category = await firstValueFrom(this.categoriesService.apiCategoriesDetailsIdGet(this.categoryId));
    } catch (error) {
      console.log('Error fetching category data:', error);
    }
  }

  goToEditCategory() {
    this.router.navigate([`/categories/${this.categoryId}/edit`]);
  }

  async showDeleteDialog(): Promise<void> {
    const deleteCheckResponses = await firstValueFrom(this.categoriesService.apiCategoriesDeleteCheckBatchPost([this.categoryId]));

    this.dialog?.show(deleteCheckResponses);
  }

  async deleteCategory(doDelete: boolean): Promise<void> {
    if (doDelete) {
      await firstValueFrom(this.categoriesService.apiCategoriesDeleteIdDelete(this.categoryId));
      this.router.navigate([`/categories`]);
    }
  }

  ngOnDestroy(): void {
    this.destroyedComponent$.next();
    this.destroyedComponent$.complete();
  }
}
